import React, { createContext, useContext, useState } from "react";

const ClientStatusContext = createContext();

export const useClientStatus = () => {
  const context = useContext(ClientStatusContext);
  if (!context) {
    throw new Error("useClientStatus must be used within a ClientStatusProvider");
  }
  return context;
};

export const ClientStatusProvider = ({ children }) => {
  // BYPASS AUTH: No localStorage checks, always active, no loading, no API calls
  const [clientState] = useState("active"); // Always active
  const [isLoading] = useState(false); // No loading
  const [error] = useState(null);

  const checkClientStatus = async () => {
    // BYPASS AUTH: No-op, always active
  };

  const refreshClientStatus = () => {
    // BYPASS AUTH: No-op
  };

  const markUserAsActive = () => {
    // BYPASS AUTH: No-op
  };

  const markOnboardingCompleted = () => {
    // BYPASS AUTH: No-op
  };

  const clearOnboardingCompletion = () => {
    // BYPASS AUTH: No-op
  };

  const handleUserLogin = () => {
    // BYPASS AUTH: No-op
  }; 

  const value = {
    clientState,
    isLoading,
    error,
    refreshClientStatus,
    checkClientStatus,
    markUserAsActive,
    markOnboardingCompleted,
    clearOnboardingCompletion,
    handleUserLogin
  };

  return (
    <ClientStatusContext.Provider value={value}>
      {children}
    </ClientStatusContext.Provider>
  );
};